import { memo } from 'react';
import { FontFamilySelect } from 'modules/common/components/FontFamilySelect';
import { MenuProps } from './TextToolbar.types';

export const FontFamily = memo(({ onChange, value }: MenuProps) => {
  return (
    <FontFamilySelect
      hasReturnFocus={false}
      fontFamily={value}
      onChange={onChange}
      borderRadius='base'
      type='toolbar'
      buttonProps={{
        width: 36,
        height: 8,
      }}
    />
  );
});
FontFamily.displayName = 'FontFamily';
